import React from "react";

export default function MSAccess_StrComp() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_StrComp</h1>
      <p>This is the MSAccess_StrComp component generated from the SQL JSON.</p>
    </div>
  );
}
